import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.beforeStreamRender = this.beforeStreamRender.bind(this)
    this.keepModal = this.keepModal.bind(this)
    this.forget = this.forget.bind(this)

    document.addEventListener('turbo:before-stream-render', this.beforeStreamRender)
    document.addEventListener('turbo:before-morph-element', this.keepModal)
    document.addEventListener('turbo:morph', this.forget)
    document.addEventListener('turbo:submit-start', this.forget)
  }

  disconnect() {
    document.removeEventListener('turbo:before-stream-render', this.beforeStreamRender)
    document.removeEventListener('turbo:before-morph-element', this.keepModal)
    document.removeEventListener('turbo:morph', this.forget)
    document.removeEventListener('turbo:submit-start', this.forget)
  }

  beforeStreamRender(event) {
    if (event.target.getAttribute('action') === 'refresh') this.refreshing = true
  }

  keepModal(event) {
    if (this.refreshing && event.target.id === 'modal' && event.target.childElementCount > 0) event.preventDefault()
  }

  forget() {
    this.refreshing = false
  }
}
